import { useEffect, useState } from "react";

export type TReportLockedTooltipTrigger = "hover" | "focus" | "click";

const FINE_POINTER_QUERY = "(hover: hover) and (pointer: fine)";

function getTooltipTrigger(): TReportLockedTooltipTrigger[] {
  if (typeof window === "undefined") {
    return ["click"];
  }

  return window.matchMedia(FINE_POINTER_QUERY).matches ? ["hover", "focus"] : ["click"];
}

export function useReportLockedTooltipTrigger(): TReportLockedTooltipTrigger[] {
  const [trigger, setTrigger] = useState<TReportLockedTooltipTrigger[]>(getTooltipTrigger);

  useEffect(() => {
    const mediaQuery = window.matchMedia(FINE_POINTER_QUERY);
    const handleChange = () => setTrigger(getTooltipTrigger());

    handleChange();
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return trigger;
}
